interface ITrackPageviewOptions {
  userIsSignedIn?: boolean;
  statusCode?: number | null | undefined;
}

export const DEFAULT_STATUS_CODE = 200;

export const trackEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel: string,
  eventValue: number
) => {
  if (typeof window === 'undefined' || !window.ga) {
    return;
  }

  window.ga('send', {
    hitType: 'event',
    eventCategory,
    eventAction,
    eventLabel,
    eventValue
  });
};

// listens for next/js routing updates and logs to GA
export const trackPageview = (
  url?: string,
  options: ITrackPageviewOptions = {}
) => {
  if (typeof window === 'undefined' || !window.ga) {
    return;
  }

  const pageviewUrl = new URL(
    url ?? window.location.href,
    window.location.origin
  );

  pageviewUrl.searchParams.set('react', '1');

  pageviewUrl.searchParams.set(
    'signedin',
    (options.userIsSignedIn === true ? 1 : 0).toString()
  );

  const statusCode = options?.statusCode ?? DEFAULT_STATUS_CODE;
  if (statusCode > 399) {
    pageviewUrl.searchParams.set('iep', statusCode.toString());
    pageviewUrl.searchParams.set('fe', 'react');
  }

  window.ga('send', {
    hitType: 'pageview',
    title: document.title,
    location: pageviewUrl.toString()
  });

  console.log('GoogleAnalytics', 'trackPageview', pageviewUrl);
};

export const setUserId = (userId: string | null) => {
  if (typeof window === 'undefined' || !userId || !window.ga) {
    return;
  }

  window.ga('send', { hitType: 'set', userId });
};
